import * as bootstrap from 'bootstrap';

export function showMailPrefModalIfExists() {
    const modalEl = document.getElementById("mailPrefModal") as HTMLElement | null;

    if (!modalEl) {
        return;
    }

    // Create Bootstrap modal instance
    const modal = new bootstrap.Modal(modalEl);

    // Track whether user explicitly dismissed via "Not Now"
    modalEl.dataset.dismissed = "false";

    // Find the dismiss button
    const dismissBtn = document.getElementById("prefDismissBtn");

    if (dismissBtn) {
        dismissBtn.addEventListener("click", () => {
            modalEl.dataset.dismissed = "true";
        });
    }

    // Handle modal hidden event
    modalEl.addEventListener("hidden.bs.modal", () => {

        if (modalEl.dataset.dismissed === "true") {

            // Reset flag for next use
            modalEl.dataset.dismissed = "false";

            // Get anti-forgery token
            const token = (document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement)?.value;

            // POST to server
            fetch("/Account/DismissGetawayPreferences", {
                method: "POST",
                headers: {
                    "RequestVerificationToken": token ?? ""
                }
            });
        }
    });

    // Finally, show the modal
    modal.show();
}

export function toggleMailPreferenceCategories() {
    const optInCheckbox = document.getElementById("RequiresEmailSignup") as HTMLInputElement | null;
    const prefsBox = document.querySelector(".mail-preference-categories") as HTMLElement | null;

    if (!optInCheckbox || !prefsBox) return;

    // Initial state
    if (optInCheckbox.checked) {
        prefsBox.style.maxHeight = prefsBox.scrollHeight + "px";
        prefsBox.style.opacity = "1";
    } else {
        prefsBox.style.maxHeight = "0";
        prefsBox.style.opacity = "0";
        prefsBox.style.overflow = "hidden";
    }

    // Listen for changes
    optInCheckbox.addEventListener("change", () => {
        if (optInCheckbox.checked) {
            prefsBox.style.display = "block"; // needed for transition if previously display:none
            const height = prefsBox.scrollHeight + "px";
            prefsBox.style.maxHeight = height;
            prefsBox.style.opacity = "1";
        } else {
            prefsBox.style.maxHeight = "0";
            prefsBox.style.opacity = "0";
        }
    });
}